import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { SchoolProvider } from '../../Hooks/SchoolContext';
import { bgGradient } from '../schoolPortal/schoolPortalTheme';

/**
 * Layout for instructor onboarding: the portal's background and providers,
 * deliberately without the sidebar.
 *
 * The sidebar is the whole point of leaving it out. Onboarding is a gate — an
 * instructor cannot use those pages yet — and showing a full nav that bounces
 * you back on every click reads as a broken portal rather than as a setup
 * flow. Nothing to click away to means nothing to bounce back from.
 *
 * SchoolProvider is mounted again here because this route tree sits outside
 * SchoolPortalLayout. GodModeProvider is above the router in App.js, so the
 * provider works the same way in both trees.
 */
export default function InstructorOnboardingLayout() {
    if (!localStorage.getItem('token')) return <Navigate to="/login" />;

    return (
        <SchoolProvider>
            <Box sx={{ minHeight: '100vh', background: bgGradient }}>
                <Outlet />
            </Box>
        </SchoolProvider>
    );
}
